export const LANGUAGE = {
  ENGLISH_UNITED_KINGDOM: 'en-UK',
  ENGLISH_UNITED_STATES: 'en-US',
  DEFAULT: 'en',
  OTHER: 'other'
};

export const LANGUAGE_KEY = "LANGUAGE";
